import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 68 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={68}
      height={52}
      fill="white"
    />
    <rect
      x={8.5}
      y={10.5}
      width={51}
      height={32}
      rx={1.5}
      stroke="#29292F"
    />
    <rect
      x={12.5}
      y={14.5}
      width={43}
      height={24}
      rx={0.5}
      fill="#FFE6ED"
      stroke="#FFD5E1"
    />
    <rect
      x={21.7368}
      y={21.866}
      width={7}
      height={1}
      rx={0.5}
      transform="rotate(136.093 21.7368 21.866)"
      fill="#FF73A9"
    />
    <rect
      x={27.6488}
      y={26.5332}
      width={11.1499}
      height={1}
      rx={0.5}
      transform="rotate(-179.924 27.6488 26.5332)"
      fill="#FF73A9"
    />
    <rect
      x={20.8545}
      y={31.0432}
      width={7}
      height={1}
      rx={0.5}
      transform="rotate(-133.907 20.8545 31.0432)"
      fill="#FF73A9"
    />
    <rect
      x={46.6284}
      y={30.2275}
      width={7}
      height={1}
      rx={0.5}
      transform="rotate(-44.8339 46.6284 30.2275)"
      fill="#FF73A9"
    />
    <rect
      x={40.6416}
      y={25.6565}
      width={11.1499}
      height={1}
      rx={0.5}
      transform="rotate(-0.850223 40.6416 25.6565)"
      fill="#FF73A9"
    />
    <rect
      x={47.3622}
      y={21.0371}
      width={7}
      height={1}
      rx={0.5}
      transform="rotate(45.1661 47.3622 21.0371)"
      fill="#FF73A9"
    />
  </svg>
);
const SvgCustomDevice = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgCustomDevice;
